import React, { useEffect, useState } from "react";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import SendIcon from "@mui/icons-material/Send";
import CelebrationIcon from "@mui/icons-material/Celebration";
import {
  Autocomplete,
  CircularProgress,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx/xlsx.mjs";
import Modal from "@mui/material/Modal";
import { Radio } from "@mui/material";
import { Box, Fade } from "@mui/material";
import JoditEditor from "jodit-react";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { ToastContainer, toast } from "react-toastify";
import RefreshIcon from "@mui/icons-material/Refresh";
import ReplyAllIcon from "@mui/icons-material/ReplyAll";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NotInterestedRoundedIcon from "@mui/icons-material/NotInterestedRounded";
import NotInterestedDeals from "../Components/NotInterestedDeals";
import ClearIcon from "@mui/icons-material/Clear";
import Switch from "@mui/material/Switch";
import noCampaignImage from "../../src/Images/ImageToStl.com_amico.avif";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Loader from "../Loader";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
  zIndex: 200,
};
const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  bgcolor: "background.paper",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
  zIndex: 200,
};

const headCells = [
  {
    id: "name",
    label: "Name",
  },
  {
    id: "calories",
    label: "From Email",
  },
  {
    id: "fat",
    label: "Created At",
  },
  {
    id: "carbs",
    label: "Amount",
  },
  {
    id: "status",
    label: "Status",
  },
];

const statusArrayObject = {
  NotInterested: {
    id: 1,
    bgHex: "#c7c7c7",
    colorHex: "#8a8888",
    text: "NotInterested",
  },
  Interested: {
    id: 2,
    bgHex: "#ffe1c2",
    colorHex: "#f7993b",
    text: "Interested",
  },
  MeetingBooked: {
    id: 3,
    bgHex: "#e3f8ff",
    colorHex: "#069ccf",
    text: "Meeting booked",
  },
  MeetingCompleted: {
    id: 3,
    bgHex: "#d2fadc",
    colorHex: "#009c35",
    text: "Meeting completed",
  },
  Closed: {
    id: 4,
    bgHex: "#bde8be",
    colorHex: "#009c35",
    text: "Meeting closed",
  },
};

const Unibox = () => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [campaigns, setCampaigns] = useState([]);
  const [emailBody, setEmailBody] = useState("");
  const [columns, setColumns] = useState({
    foo: {
      id: "foo",
      title: "All (Replies)",
      icon: <ReplyAllIcon style={{ color: "#1C485F", fontSize: "20px" }} />,
      cards: [],
    },
    todo: {
      id: "todo",
      title: "Interested",
      icon: <ThumbUpIcon style={{ color: "#1C485F", fontSize: "20px" }} />,
      cards: [],
    },
    inProgress: {
      id: "inProgress",
      title: "Meeting Booked",
      icon: <SendIcon style={{ color: "#1C485F", fontSize: "20px" }} />,
      cards: [],
    },
    done: {
      id: "done",
      title: "Meeting Completed",
      icon: <CheckCircleIcon style={{ color: "#1C485F", fontSize: "20px" }} />,
      cards: [],
    },
    sooper: {
      id: "sooper",
      title: "Closed",
      icon: <CelebrationIcon style={{ color: "#1C485F", fontSize: "20px" }} />,
      cards: [],
    },
  });
  const [countryTimeSchedule, setCountryTimeSchdule] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [selectedReply, setSelectedReply] = useState({});
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [detailsId, setDetailsId] = useState("");
  const [replyIdId, setReplyId] = useState("");
  const [clickedColumn, setClickedColumn] = useState("All (Replies)");
  const [isClickedAllReplyCard, setIsClickedAllReplyCard] = useState(false);
  const [calendlyData, setCalendlyData] = useState([]);
  const [replyData, setReplyData] = useState([]);
  const [selectedEmailDetails, setSelectedEmailDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showNotInterestedTable, setShowNotInterestedTable] = useState(false);
  const [notInterestedCampaignId, setNotInterestedCampaignId] = useState(null);
  const [catchAmount, setCatchAmount] = useState("");
  const [checked, setChecked] = useState(false);
  const [fileType, setFileType] = useState("CSV");
  const [refreshNotInterestedData, setRefreshNotInterestedData] =
    useState(false);

  const [tableViewData, setTableViewData] = useState([]);

  useEffect(() => {
    let allCards = [];
    for (let key in columns) {
      allCards = allCards.concat(columns[key].cards);
    }
    setTableViewData(allCards);
  }, [checked]);

  const handleDragStart = (e, card, columnId) => {
    console.log("nnfn");
    e.dataTransfer.setData("card", JSON.stringify(card));
    e.dataTransfer.setData("columnId", columnId);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleToggleView = (event) => {
    setChecked(event.target.checked);
  };

  const handleDrop = (e, targetColumnId) => {
    const draggedCard = JSON.parse(e.dataTransfer.getData("card"));
    const sourceColumnId = e.dataTransfer.getData("columnId");
    console.log("dragged card", draggedCard);
    if (sourceColumnId !== targetColumnId) {
      const updatedColumns = { ...columns };
      const sourceColumn = { ...updatedColumns[sourceColumnId] };
      const targetColumn = { ...updatedColumns[targetColumnId] };

      sourceColumn.cards = sourceColumn.cards.filter(
        (c) => c._id !== draggedCard._id
      );

      targetColumn.cards.push(draggedCard);

      updatedColumns[sourceColumnId] = sourceColumn;
      updatedColumns[targetColumnId] = targetColumn;

      setColumns(updatedColumns);
    }
    if (targetColumnId === "foo") {
      changeStatusOfReplyCards(
        draggedCard._id,
        draggedCard.detailsId,
        "make-reply-again",
        draggedCard.campId
      );
    } else if (targetColumnId === "todo") {
      changeStatusOfReplyCards(
        draggedCard._id,
        draggedCard.detailsId,
        "make-reply-interested",
        draggedCard.campId
      );
    } else if (targetColumnId === "inProgress") {
      changeStatusOfReplyCards(
        draggedCard._id,
        draggedCard.detailsId,
        "make-reply-meeting-booked",
        draggedCard.campId
      );
    } else if (targetColumnId === "done") {
      changeStatusOfReplyCards(
        draggedCard._id,
        draggedCard.detailsId,
        "make-reply-meeting-completed",
        draggedCard.campId
      );
    } else if (targetColumnId === "sooper") {
      changeStatusOfReplyCards(
        draggedCard._id,
        draggedCard.detailsId,
        "make-reply-meeting-closed",
        draggedCard.campId
      );
    }
  };

  const handleChange9 = (event, newValue) => {
    if (newValue !== null) {
      setSelectedCampaign(newValue.campaignDetails._id);
      if (!showNotInterestedTable) {
        getCampaignReplyDetails(newValue.campaignDetails._id);
      }
      setNotInterestedCampaignId(newValue.campaignDetails._id);
      setCountryTimeSchdule(newValue);
    }
  };
  function getCampaignReplyDetails(id) {
    setIsLoading(true);
    columns.foo.cards = [];
    columns.done.cards = [];
    columns.sooper.cards = [];
    columns.inProgress.cards = [];
    columns.todo.cards = [];
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/automation/get-reply-campaign/${
          userDetails && userDetails.details._id
        }/${id}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setReplyData(response.data.details);
          let all = [];
          let todo = [];
          let inProgress = [];
          let done = [];
          let sooper = [];
          response.data.details.Details.map((val) => {
            val.Reply.map((value) => {
              value.toEmail = val.Email;
              value.detailsId = val._id;
              value.campId = response.data.details.CampaignId;
              value.emailDetails = val.EmailDetails;
              if (!value.NotInterested) {
                if (
                  !value.Closed &&
                  !value.Interested &&
                  !value.MeetingBooked &&
                  !value.MeetingCompleted
                ) {
                  all.push(value);
                } else if (value.Interested) {
                  todo.push(value);
                } else if (value.MeetingBooked) {
                  inProgress.push(value);
                } else if (value.MeetingCompleted) {
                  done.push(value);
                } else if (value.Closed) {
                  sooper.push(value);
                }
              }
            });
          });
          columns.foo.cards = all;
          columns.todo.cards = todo;
          columns.inProgress.cards = inProgress;
          columns.done.cards = done;
          columns.sooper.cards = sooper;
          setColumns({ ...columns });
          setIsLoading(false);
        } else {
          setReplyData([]);
          columns.foo.cards = [];
          columns.done.cards = [];
          columns.sooper.cards = [];
          columns.inProgress.cards = [];
          columns.todo.cards = [];
          setColumns({ ...columns });
          setIsLoading(false);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    setSelectedCampaign("");
  }, [showNotInterestedTable]);
  function getAllCampaigns() {
    getAllCampaignsReply();
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/automation/get-all-user-campaign/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          // console.log(response.data.details);
          setCampaigns(response.data.details);
          // getCampaignReplyDetails(response.data.details[0].campaignDetails._id);

          // setSelectedCampaign(response.data.details[0].campaignDetails._id);
        } else {
          setCampaigns([]);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  useEffect(() => {
    getAllCampaigns();
  }, []);

  const dropDownUi = () => {
    return (
      <Autocomplete
        displayEmpty
        disabled={checked}
        variant="standard"
        value={countryTimeSchedule}
        disableUnderline
        getOptionLabel={(option) => option.campaignDetails.Name}
        options={campaigns}
        onChange={handleChange9}
        sx={{
          backgroundColor: "#FAFAFA",
          borderRadius: "4px",
          fontFamily: "Source Sans 3",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 400,
          color: "#4B4B4B",
          maxHeight: 160,
          overflowY: "auto",
        
          "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              borderColor: "#eee",
            },
        }}
        renderInput={(params) => (
          <TextField
            placeholder="All Campaigns"
            sx={{
              padding:'-1px',
              outline: "none",
            }}
            {...params}
          />
        )}
        inputProps={{ "aria-label": "Without label" }}
        MenuProps={{
          PaperProps: {
            style: {
              height: 160,
              overflowY: "auto",
            },
          },
        }}
      />
    );
  };

  const configurations = {
    readonly: false,
    buttons: "undo,redo,font,fontsize,bold,italic,underline,ol,ul,center",
    toolbarAdaptive: false,
    showCharsCounter: false,
    showXPathInStatusbar: false,
    statusbar: false,
  };

  const handleContent = (content) => {
    setEmailBody(content);
    // console.log("content", content);
  };

  const getAllCalendlyData = (token, organization, reftoken, owner) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `https://api.calendly.com/event_types?active=true&organization=${organization}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        setCalendlyData(response.data);
        setOpen3(true);
        console.log("response data", response.data);
        let data = JSON.stringify({
          url: "https://mail.goone.club/email-marketing/automation/trigger-calendly-email-lead-main",
          events: [
            "invitee.created",
            "invitee.canceled",
            "invitee_no_show.created",
          ],
          organization: organization,
          user: owner,
          scope: "organization",
          // "signing_key": "YYJYULqMncq9ksIwtFDvs_EZ7tBnK_8x8sF-caz81TU"
        });
        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://api.calendly.com/webhook_subscriptions",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          data: data,
        };
        axios
          .request(config)
          .then((response) => {
            toast.success("web hook connected successfully", {
              autoClose: true,
              position: "top-right",
              duration: 3000,
            });
          })
          .catch((error) => {
            // toast.error(
            //   "Please upgrade your calendly account to standard plan or higher",
            //   {
            //     autoClose: true,
            //     position: "top-right",
            //     duration: 3000,
            //   }
            // );
          });
      })
      .catch((error) => {
        createAccessToken(reftoken, organization, owner);
      });
  };

  const createAccessToken = (refToken, organization, owner) => {
    axios
      .post(
        `https://calendly.com/oauth/token?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&client_secret=QP2iUiADJkDBQzFudVSdKU_llhekpna7sNZ73lLgqRQ&refresh_token=${refToken}&grant_type=refresh_token`
      )
      .then((result) => {
        if (result.data) {
          let accData = {
            calendlyAccessToken: result.data.access_token,
          };
          axios
            .put(
              `${
                BaseUrl.baseurl
              }/email-marketing/user/update-user-calendly-access-token/${
                userDetails && userDetails.details._id
              }`,
              accData,
              {
                headers: {
                  Authorization: `Bearear ${userDetails && userDetails.token}`,
                },
              }
            )
            .then((response) => {
              if (response.data.status) {
                getAllCalendlyData(
                  result.data.access_token,
                  organization,
                  refToken,
                  owner
                );
              } else {
                if (response.data.tokenExpire) {
                  localStorage.removeItem("MailSenderuserDetails");
                  window.location.reload();
                }
              }
            })
            .catch((err) => console.log("Error"));
        }
      })
      .catch((err) => {
        window.location.href =
          "https://calendly.com/oauth/authorize?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&redirect_uri=https://app.coldsender.com/Calendly-verify/&response_type=code";
      });
  };

  const connectCalendly = () => {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user/get-user-info-by-id/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          if (response.data.details.CalendlyAddedStatus) {
            getAllCalendlyData(
              response.data.details.CalendlyAccessToken,
              response.data.details.CalendlyOrganization,
              response.data.details.CalendlyRefreshToken,
              response.data.details.CalendlyOwner
            );
          } else {
            // this.props.setLocalStorageData();
            window.location.href =
              "https://calendly.com/oauth/authorize?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&redirect_uri=https://app.coldsender.com/Calendly-verify/&response_type=code";
          }
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error===================", err));
  };
  function changeStatusOfReplyCards(reply, details, type, campId) {
    let data = {
      detailsId: details,
      replyId: reply,
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/automation/${type}/${
          userDetails && userDetails.details._id
        }/${campId}`,
        data,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          // no need to call getAllCampaignsReply this function
          getAllCampaignsReply();
          // getCampaignReplyDetails(selectedCampaign);
          toast.success(response.data.message);
        } else {
          toast.success(response.data.message);
          setCampaigns([]);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setOpenModal(false);
      })
      .catch((err) => console.log("Error"));
  }
  const allCardInfoModalUi = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={() => setOpenModal(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openModal}>
          <Box sx={style}>
            <div className="space-y-3">
              <p
                style={{
                  color: "#4B4B4B",
                  fontWeight: 700,
                  fontStyle: "normal",
                  lineHeight: "20px",
                  fontSize: "24px",
                  fontFamily: "Source Sans 3",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                All Deals
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  <span
                    style={{
                      color: "#4B4B4B",
                      fontWeight: 700,
                      fontStyle: "normal",
                      fontSize: "16px",
                      fontFamily: "Source Sans 3",
                    }}
                  >
                    To:
                  </span>
                  {selectedReply.toEmail}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  <span
                    style={{
                      color: "#4B4B4B",
                      fontWeight: 700,
                      fontStyle: "normal",
                      fontSize: "16px",
                      fontFamily: "Source Sans 3",
                    }}
                  >
                    From:
                  </span>
                  {selectedReply?.Data?.Email}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  <span
                    style={{
                      color: "#4B4B4B",
                      fontWeight: 700,
                      fontStyle: "normal",
                      fontSize: "16px",
                      fontFamily: "Source Sans 3",
                    }}
                  >
                    Subject:
                  </span>
                  {selectedReply?.Data?.Subject}
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "transparent",
                  borderRadius: 4,
                  padding: "4px",
                  height: "200px",
                  overflow: "auto",
                }}
                dangerouslySetInnerHTML={{
                  __html: selectedReply?.Data?.Text,
                }}
              />
            </div>
            {!showNotInterestedTable ? (
              <div
                style={{
                  display: "flex",
                  paddingTop: "12px",
                  justifyContent: "flex-end",
                  gap: "13px",
                }}
              >
                <button
                  onClick={() => setOpenModal(false)}
                  style={{
                    border: "1px solid #1C485F",
                    outline: "none",
                    color: "#1C485F",
                    padding: "9px 16px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "4px",
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    changeStatusOfReplyCards(
                      replyIdId,
                      detailsId,
                      "make-reply-not-interested",
                      selectedCampaign
                    );
                  }}
                  style={{
                    border: "1px solid #1C485F",
                    outline: "none",
                    color: "#1C485F",
                    padding: "9px 16px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "4px",
                  }}
                >
                  Not interested
                </button>
                <button
                  onClick={() => {
                    changeStatusOfReplyCards(
                      replyIdId,
                      detailsId,
                      "make-reply-interested",
                      selectedCampaign
                    );
                  }}
                  style={{
                    textTransform: "none",
                    outline: "none",
                    color: "#fff",
                    padding: "10px 26px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "6px",
                  }}
                  className="bg-primary"
                >
                  Interested
                </button>
              </div>
            ) : null}
          </Box>
        </Fade>
      </Modal>
    );
  };

  function bookMeetingOfReply() {
    let data = {
      fromEmail: selectedEmailDetails,
      toEmail: selectedReply.Data.Email,
      subject: selectedReply.Data.Subject,
      content: emailBody,
    };
    axios
      .post(
        `${
          BaseUrl.baseurl
        }/email-marketing/automation/send-reply-email-campaign/${
          userDetails && userDetails.details._id
        }/${selectedCampaign}`,
        data,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          // changeStatusOfReplyCards(
          //   replyIdId,
          //   detailsId,
          //   "make-reply-meeting-booked",
          //   selectedCampaign
          // );
          toast.success(response.data.message);
        } else {
          toast.success(response.data.message);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setOpenModal(false);
      })
      .catch((err) => console.log("Error"));
  }
  const IntrestedCardInfoModalUi = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={() => setOpenModal(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openModal}>
          <Box sx={style2}>
            <div className="space-y-2">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    color: "#4B4B4B",
                    fontWeight: "700",
                    fontStyle: "normal",
                    fontSize: "24px",
                    lineHeight: "20px",
                    fontFamily: "Source Sans 3",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Interested Deals
                </p>
                <button
                  onClick={connectCalendly}
                  style={{
                    backgroundColor: "#FF3301",
                    outline: "none",
                    color: "#FFF",
                    padding: "9px 16px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "4px",
                  }}
                >
                  Calendly
                </button>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  <span
                    style={{
                      color: "#4B4B4B",
                      fontWeight: 700,
                      fontStyle: "normal",
                      fontSize: "16px",
                      fontFamily: "Source Sans 3",
                    }}
                  >
                    To:
                  </span>
                  {selectedReply.toEmail}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  <span
                    style={{
                      color: "#4B4B4B",
                      fontWeight: 700,
                      fontStyle: "normal",
                      fontSize: "16px",
                      fontFamily: "Source Sans 3",
                    }}
                  >
                    From:
                  </span>
                  {selectedReply.Data.Email}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                  }}
                >
                  <span
                    style={{
                      color: "#4B4B4B",
                      fontWeight: 700,
                      fontStyle: "normal",
                      fontSize: "16px",
                      fontFamily: "Source Sans 3",
                    }}
                  >
                    Subject:
                  </span>
                  {selectedReply.Data.Subject}
                </div>
              </div>
              <div
                style={{
                  height: "200px",
                  display: "flex",
                  overflow: "auto",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: "50%",
                    backgroundColor: "#FFF",
                    height: "max-content",
                  }}
                >
                  <div
                    style={{
                      borderRadius: 4,
                      width: "100%",
                      padding: "4px 4px 4px 20px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: selectedReply.Data.Text,
                      style: {
                        overflowWrap: "break-word",
                        wordWrap: "break-word",
                      },
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "50%",
                    position: "sticky",
                    top: 0,
                    right: 0,
                  }}
                >
                  <JoditEditor
                    onBlur={handleContent}
                    value={emailBody}
                    config={configurations}
                    placeholder="Enter something here..."
                    style={{ height: "100%", width: "100%" }}
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: isClickedAllReplyCard
                  ? "space-between"
                  : "flex-end",
                alignItems: "center",
                paddingTop: "12px",
              }}
            >
              {isClickedAllReplyCard && (
                <button
                  onClick={() => {
                    changeStatusOfReplyCards(
                      replyIdId,
                      detailsId,
                      "make-reply-interested",
                      selectedCampaign
                    );
                  }}
                  style={{
                    textTransform: "none",
                    outline: "none",
                    color: "#fff",
                    padding: "10px 26px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "6px",
                  }}
                  className="bg-primary"
                >
                  Interested
                </button>
              )}
              <div
                style={{
                  display: "flex",
                  gap: "13px",
                }}
              >
                <button
                  onClick={() => setOpenModal(false)}
                  style={{
                    border: "1px solid #1C485F",
                    outline: "none",
                    color: "#1C485F",
                    padding: "9px 16px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "4px",
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    changeStatusOfReplyCards(
                      replyIdId,
                      detailsId,
                      "make-reply-not-interested",
                      selectedCampaign
                    );
                  }}
                  style={{
                    border: "1px solid #1C485F",
                    outline: "none",
                    color: "#1C485F",
                    padding: "9px 16px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "4px",
                  }}
                >
                  Not interested
                </button>
                <button
                  onClick={() => {
                    bookMeetingOfReply();
                  }}
                  style={{
                    backgroundColor: "#FF3301",
                    outline: "none",
                    color: "#FFF",
                    padding: "9px 16px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "4px",
                  }}
                >
                  Send Reply
                </button>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };

  const handleUpdateAmount = () => {
    if (catchAmount.toString().length > 0) {
      let data = {
        detailsId,
        replyId: replyIdId,
        amount: parseInt(catchAmount),
      };
      axios
        .put(
          `${
            BaseUrl.baseurl
          }/email-marketing/automation/change-amount-of-deal/${
            userDetails && userDetails.details._id
          }/${selectedCampaign}`,
          data,
          {
            headers: {
              Authorization: `Bearear ${userDetails && userDetails.token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            toast.success(response.data.message);
            setOpenModal(false);
            getAllCampaignsReply();
          } else {
            setCampaigns([]);
            toast.error(response.data.message);
            setOpenModal(false);
            if (response.data.tokenExpire) {
              localStorage.removeItem("MailSenderuserDetails");
              window.location.reload();
            }
          }
        })
        .catch((err) => console.log("Error"));
    } else {
      toast.error("**At least one digit number is required!");
    }
  };

  const updateCardAmountModalUi = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={() => setOpenModal(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openModal}>
          <Box sx={style}>
            <div className="space-y-4">
              <p
                style={{
                  color: "#4B4B4B",
                  fontWeight: "700",
                  fontStyle: "normal",
                  fontSize: "24px",
                  lineHeight: "20px",
                  fontFamily: "Source Sans 3",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                Update Amount
              </p>
              <div>
                <label
                  htmlFor="amount-up"
                  style={{
                    color: "#4B4B4B",
                    fontWeight: "400",
                    marginBottom: 4,
                    fontStyle: "normal",
                    fontSize: "12px",
                  }}
                >
                  Enter Amount
                </label>
                <input
                  id="amount-up"
                  type="number"
                  placeholder="Enter Amount"
                  onChange={(e) => {
                    setCatchAmount(e.target.value);
                  }}
                  style={{
                    backgroundColor: "#FAFAFA",
                    outline: "none",
                    border: "1px solid #DDD",
                    padding: "8px 6px",
                    borderRadius: 5,
                    width: "100%",
                  }}
                  value={catchAmount}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                paddingTop: "12px",
                justifyContent: "flex-end",
                gap: "13px",
              }}
            >
              <button
                onClick={() => setOpenModal(false)}
                style={{
                  border: "1px solid #1C485F",
                  outline: "none",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "4px",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateAmount}
                style={{
                  backgroundColor: "#FF3301",
                  outline: "none",
                  color: "#FFF",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "4px",
                }}
              >
                Continue
              </button>
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };
  function changeDateFormat(date) {
    const inputDate = new Date(date);
    const options = { month: "short", day: "numeric", year: "numeric" };
    const formattedDate = inputDate.toLocaleDateString("en-US", options);
    return formattedDate;
  }
  function getAllCampaignsReply() {
    setIsLoading(true);
    columns.foo.cards = [];
    columns.done.cards = [];
    columns.sooper.cards = [];
    columns.inProgress.cards = [];
    columns.todo.cards = [];
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/automation/get-all-reply-campaign/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setReplyData(response.data.details);
          let all = [];
          let todo = [];
          let inProgress = [];
          let done = [];
          let sooper = [];
          response.data.details.map((item) => {
            item.Details.map((val) => {
              val.Reply.map((value) => {
                value.toEmail = val.Email;
                value.detailsId = val._id;
                value.campId = item.CampaignId;
                value.emailDetails = val.EmailDetails;
                if (!value.NotInterested) {
                  if (
                    !value.Closed &&
                    !value.Interested &&
                    !value.MeetingBooked &&
                    !value.MeetingCompleted
                  ) {
                    all.push(value);
                  } else if (value.Interested) {
                    todo.push(value);
                  } else if (value.MeetingBooked) {
                    inProgress.push(value);
                  } else if (value.MeetingCompleted) {
                    done.push(value);
                  } else if (value.Closed) {
                    sooper.push(value);
                  }
                }
              });
            });
          });

          columns.foo.cards = all;
          columns.todo.cards = todo;
          columns.inProgress.cards = inProgress;
          columns.done.cards = done;
          columns.sooper.cards = sooper;
          setColumns({ ...columns });
          setIsLoading(false);
        } else {
          setReplyData([]);
          columns.foo.cards = [];
          columns.done.cards = [];
          columns.sooper.cards = [];
          columns.inProgress.cards = [];
          columns.todo.cards = [];
          setColumns({ ...columns });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  function getRefreshedCampaignReply() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/automation/refresh-reply-campaign/${
          userDetails && userDetails.details._id
        }/${selectedCampaign}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          getCampaignReplyDetails(selectedCampaign);
        }
      })
      .catch((err) => console.log("Error"));
  }
  const catchPropsFromNotInterestedComponent = (data) => {
    setSelectedReply(data.Data);
    setOpenModal(true);
    setClickedColumn(data.title);
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableViewData.length) : 0;

  const kanbanViewUi = () => {
    return (
      <div className="kanban-board">
        {Object.values(columns).map((column) => (
          <div
            key={column.id}
            className="kanban-column"
            style={{
              padding:
                column.cards.length === 0 ? "10px 10px 40px 10px" : "10px",
            }}
            onDragOver={(e) => handleDragOver(e)}
            onDrop={(e) => handleDrop(e, column.id)}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 5,
                margin: "4px 0px",
              }}
            >
              {column.icon}
              <p
                style={{
                  color: "#1C485F",
                  fontSize: "15px",
                  fontWeight: 700,
                  letterSpacing: 0.7,
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                {column.title}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "6px 0px",
              }}
            >
              <p
                style={{
                  color: "#1C485F",
                  fontSize: "14px",
                  fontWeight: 400,
                  letterSpacing: 0.7,
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                {/* Total Money: ${calculateTotalMoney(column.id)} */}
              </p>
              <p
                style={{
                  color: "#1C485F",
                  fontSize: "14px",
                  fontWeight: 400,
                  letterSpacing: 0.7,
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                  marginTop: "0px",
                }}
              >
                {column.cards.length} deals
              </p>
            </div>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress sx={{ color: "#1C485F" }} />
              </div>
            ) : (
              column.cards.length !== 0 &&
              column.cards.map((card, index) => {
                return (
                  <div
                    key={index}
                    draggable
                    onDragStart={(e) => handleDragStart(e, card, column.id)}
                    className="kanban-card"
                  >
                    <p
                      onClick={() => {
                        setSelectedReply(card);
                        setDetailsId(card.detailsId);
                        setReplyId(card._id);
                        setSelectedCampaign(card.campId);
                        setOpenModal(true);
                        if (column.title === "All (Replies)") {
                          setIsClickedAllReplyCard(true);
                        } else {
                          setIsClickedAllReplyCard(false);
                        }
                        setSelectedEmailDetails(card.emailDetails);
                        setClickedColumn("Interested");
                      }}
                      style={{
                        color: "#1C485F",
                        fontSize: "14px",
                        fontWeight: 700,
                        letterSpacing: 0.7,
                        fontFamily: "Source Sans 3",
                        fontStyle: "normal",
                      }}
                    >
                      {card?.Data.Name !== " " ? card?.Data.Name : "No-Name"}
                    </p>
                    <p
                      onClick={() => {
                        setSelectedReply(card);
                        setDetailsId(card.detailsId);
                        setReplyId(card._id);
                        setSelectedCampaign(card.campId);
                        setOpenModal(true);
                        if (column.title === "All (Replies)") {
                          setIsClickedAllReplyCard(true);
                        } else {
                          setIsClickedAllReplyCard(false);
                        }
                        setSelectedEmailDetails(card.emailDetails);
                        setClickedColumn("Interested");
                        // console.log("titles", column.title);
                      }}
                      style={{
                        color: "#000",
                        fontSize: "13px",
                        fontWeight: 400,
                        letterSpacing: 0.7,
                        fontFamily: "Source Sans 3",
                        fontStyle: "normal",
                        marginTop: "0px",
                      }}
                    >
                      {card.FromEmail}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        position: "relative",
                      }}
                    >
                      <p
                        onClick={() => {
                          setSelectedReply(card);
                          setDetailsId(card.detailsId);
                          setReplyId(card._id);
                          setSelectedCampaign(card.campId);
                          setOpenModal(true);
                          if (column.title === "All (Replies)") {
                            setIsClickedAllReplyCard(true);
                          } else {
                            setIsClickedAllReplyCard(false);
                          }
                          setClickedColumn("Interested");
                          setSelectedEmailDetails(card.emailDetails);
                          // console.log("titles", column.title);
                        }}
                        style={{
                          color: "#000",
                          fontSize: "12px",
                          fontWeight: 400,
                          letterSpacing: 0.7,
                          fontFamily: "Source Sans 3",
                          fontStyle: "normal",
                          marginTop: "0px",
                        }}
                      >
                        {changeDateFormat(card.Data.Date)}
                      </p>
                      <p
                        style={{
                          color: "#000",
                          fontSize: "14px",
                          cursor: "pointer",
                          fontWeight: 700,
                          letterSpacing: 0.7,
                          fontFamily: "Source Sans 3",
                          fontStyle: "normal",
                          marginTop: "0px",
                          position: "absolute",
                          right: 0,
                          zIndex: 200,
                        }}
                        onClick={() => {
                          console.log("Card", card);
                          setOpenModal(true);
                          setDetailsId(card.detailsId);
                          setReplyId(card._id);
                          setSelectedCampaign(card.campId);
                          setSelectedEmailDetails(card.emailDetails);
                          setClickedColumn("Amount");
                          setCatchAmount(card.Amount);
                        }}
                      >
                        {card.Amount}
                      </p>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        ))}
      </div>
    );
  };

  const tableViewUi = () => {
    return (
      <Box sx={{ width: "100%" }}>
        <Paper
          sx={{
            width: "100%",
            borderRadius: "6px",
            boxShadow: "none",
          }}
        >
          {/* <GoalContacts /> */}
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={"medium"}
            >
              {isLoading ? (
                // this body for display loading
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={headCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                          padding: "130px 0px",
                        }}
                      >
                        <Loader />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : tableViewData.length > 0 ? (
                <>
                  {/* table header */}
                  <TableHead>
                    <TableRow
                      sx={{ backgroundColor: "#FAFAFA", borderRadius: "4px" }}
                    >
                      {headCells.map((headCell) => (
                        <TableCell key={headCell.id} align="left">
                          <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            fontSize={"13px"}
                          >
                            {headCell.label}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {/* // this body is for displaying data */}
                  <TableBody>
                    {tableViewData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            backgroundColor:
                              index % 2 === 0 ? "#FFF" : "#FAFAFA",
                          }}
                        >
                          <TableCell align="left">
                            <p
                              style={{
                                marginTop: "0px",
                                fontFamily: "Source Sans 3",
                                fontSize: "15px",
                                fontStyle: "normal",
                                fontWeight: 700,
                                color: "#1C485F",
                              }}
                            >
                              {row?.Data?.Name}
                            </p>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <p
                              style={{
                                marginTop: "0px",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                color: "#868686",
                              }}
                            >
                              {row?.Data?.Email}
                            </p>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <p
                              style={{
                                marginTop: "0px",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                color: "#868686",
                              }}
                            >
                              {changeDateFormat(row?.Data?.Date)}
                            </p>
                          </TableCell>

                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              {row.Amount}
                            </Box>
                          </TableCell>
                          <TableCell align="left" sx={{ color: "#868686" }}>
                            <Box
                              sx={{
                                backgroundColor: row.Closed
                                  ? statusArrayObject.Closed.bgHex
                                  : row.Interested
                                  ? statusArrayObject.Interested.bgHex
                                  : row.MeetingBooked
                                  ? statusArrayObject.MeetingBooked.bgHex
                                  : row.MeetingCompleted
                                  ? statusArrayObject.MeetingCompleted.bgHex
                                  : statusArrayObject.NotInterested.bgHex,
                                color: row.Closed
                                  ? statusArrayObject.Closed.colorHex
                                  : row.Interested
                                  ? statusArrayObject.Interested.colorHex
                                  : row.MeetingBooked
                                  ? statusArrayObject.MeetingBooked.colorHex
                                  : row.MeetingCompleted
                                  ? statusArrayObject.MeetingCompleted.colorHex
                                  : statusArrayObject.NotInterested.colorHex,
                                borderRadius: "25px",
                                textAlign: "center",
                                padding: "10px 0px",
                                fontWeight: 700,
                                minWidth: "100px",
                              }}
                            >
                              {row.Closed
                                ? statusArrayObject.Closed.text
                                : row.Interested
                                ? statusArrayObject.Interested.text
                                : row.MeetingBooked
                                ? statusArrayObject.MeetingBooked.text
                                : row.MeetingCompleted
                                ? statusArrayObject.MeetingCompleted.text
                                : statusArrayObject.NotInterested.text}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </>
              ) : (
                // this body for displaying empty data
                <TableBody>
                  <TableRow>
                    <TableCell
                      colSpan={headCells.length}
                      align="center"
                      sx={{ borderBottom: "0px" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <img
                          src={noCampaignImage}
                          alt="Nothing found"
                          style={{ height: "250px" }}
                        />
                        <p
                          style={{
                            fontFamily: "Source Sans 3",
                            fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            color: "#393939",
                          }}
                        >
                          No data found
                        </p>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={headCells.length} />
                </TableRow>
              )}
            </Table>
          </TableContainer>
          {isLoading
            ? null
            : tableViewData.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={tableViewData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              )}
        </Paper>
      </Box>
    );
  };
  const downloadFileArr = [
    {
      id: 1,

      name: "CSV",
    },
    {
      id: 2,

      name: "XLSX",
    },
  ];
  const JSONToCSV = (data) => {
    const keys = Object.keys(data[0]);
    const csvData = [keys.join(",")];

    for (let item of data) {
      const values = keys.map((key) => item[key]);
      csvData.push(values.join(","));
    }

    return csvData.join("\n");
  };
  function downloadBulk(exportJson) {
    setOpen3(false);
    if (fileType === "CSV") {
      // console.log("selectedbulk", exportJson);

      const csvContent = "data:text/csv;charset=utf-8," + JSONToCSV(exportJson);
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `replyleads.csv`);
      link.click();
    } else if (fileType === "XLSX") {
      const ws = XLSX.utils.json_to_sheet(exportJson);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, `replyleads.xlsx`);
    }
  }
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight (0 hours)
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    return formattedDate;
  }
  return (
    <div style={{ position: "relative", height: "100%", overflow: "auto" }}>
      {openModal
        ? clickedColumn === "Interested"
          ? IntrestedCardInfoModalUi()
          : clickedColumn === "Amount"
          ? updateCardAmountModalUi()
          : allCardInfoModalUi()
        : null}

      <div className="p-4 border border-gray-400 bg-white rounded-md">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
            borderBottom: "1px solid #DDD",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div
              style={{
                width: "400px",
              }}
            >
              {dropDownUi()}
            </div>
            <button
              disabled={checked}
              onClick={() => {
                setCountryTimeSchdule(null);
                setSelectedCampaign("");
                if (showNotInterestedTable) {
                  setRefreshNotInterestedData(!refreshNotInterestedData);
                } else {
                  getAllCampaignsReply();
                }
              }}
              style={{
                border: "1px solid #1C485F",
                outline: "none",
                color: "#1C485F",
                padding: "9px 16px",
                fontSize: "14px",
                fontWeight: "400",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M1.66667 7.08332C1.66667 4.16666 3.33334 2.91666 5.83334 2.91666H14.1667C16.6667 2.91666 18.3333 4.16666 18.3333 7.08332V12.9167C18.3333 15.8333 16.6667 17.0833 14.1667 17.0833H5.83334"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.1667 7.5L11.5583 9.58333C10.7 10.2667 9.29166 10.2667 8.43332 9.58333L5.83333 7.5"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.66667 13.75H6.66667"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.66667 10.4167H4.16667"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              All Campaigns
            </button>
            {!showNotInterestedTable && (
              <button
                disabled={selectedCampaign === ""}
                onClick={() => {
                  getRefreshedCampaignReply();
                }}
                style={{
                  border: "1px solid #1C485F",
                  outline: "none",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  gap: 3,
                }}
              >
                <RefreshIcon sx={{ height: 21 }} />
                Refresh
              </button>
            )}
            {!showNotInterestedTable && (
              <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <p
                  style={{
                    color: !checked ? "#1C485F" : "#868686",
                    fontSize: "14px",
                    fontWeight: 600,
                    letterSpacing: "1px",
                  }}
                >
                  Card View
                </p>
                <Switch
                  checked={checked}
                  onChange={handleToggleView}
                  inputProps={{ "aria-label": "controlled" }}
                />
                <p
                  style={{
                    color: !checked ? "#868686" : "#1C485F",
                    fontSize: "14px",
                    fontWeight: 600,
                    letterSpacing: "1px",
                  }}
                >
                  Table View
                </p>
              </div>
            )}
            {checked && (
              <button
                onClick={() => {
                  setOpen4(true);
                }}
                disabled={tableViewData.length === 0}
                style={{
                  fontSize: "10px",
                  outline: "none",
                  textTransform: "none",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <DownloadIcon />
              </button>
            )}
          </div>
          {!showNotInterestedTable && (
            <button
              onClick={() => {
                setCountryTimeSchdule(null);
                setShowNotInterestedTable(true);
              }}
              style={{
                border: "1px solid #1C485F",
                outline: "none",
                color: "#1C485F",
                padding: "9px 16px",
                fontSize: "14px",
                fontWeight: "400",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                gap: 5,
              }}
            >
              <NotInterestedRoundedIcon
                style={{ color: "#1C485F", height: 21 }}
              />
              Not interested
            </button>
          )}
        </div>
        {showNotInterestedTable ? (
          <NotInterestedDeals
            setOpenModal={catchPropsFromNotInterestedComponent}
            setShowNotInterestedTable={setShowNotInterestedTable}
            notInterestedCampaignId={countryTimeSchedule}
            refreshNotInterestedData={refreshNotInterestedData}
            setCountryTimeSchdule={setCountryTimeSchdule}
          />
        ) : checked ? (
          tableViewUi()
        ) : (
          kanbanViewUi()
        )}
      </div>
      <ToastContainer />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open3}
        onClose={() => setOpen3(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open3}>
          <Box sx={style}>
            <div className="calendlymeethead" style={{ padding: "5px" }}>
              Available Calendly meeting{" "}
              <ClearIcon
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpen3(false);
                }}
              />
            </div>
            <div className="listcalendlybos" style={{ padding: "10px" }}>
              {calendlyData?.length !== 0 &&
                calendlyData?.collection.length === 0 && (
                  <div className="subheadcalendl">
                    No Calendly Link present. Please create calendly schedule in
                    calendly site.
                  </div>
                )}

              {calendlyData?.length !== 0 &&
                calendlyData?.collection.map((val) => {
                  let dmUrl = val.scheduling_url;
                  return (
                    <>
                      {val.active && (
                        <div className="calendlyboxalign">
                          <div className="insideboixcalend">
                            <div className="calendtexthead">{val.name}</div>
                            <div className="subheadcalendl">
                              {val.duration}mins /
                              {dmUrl.replace("https://calendly.com/", "")}
                            </div>
                          </div>
                          <div
                            className="inserlinkcALEND"
                            onClick={() => {
                              setEmailBody(
                                (prevString) =>
                                  prevString +
                                  `&nbsp<a style='color:#0000FF' href=${val.scheduling_url}?utm_source=userId&utm_content=node&utm_campaign=campaignId target="_blank" rel="noopener"> ${val.name} </a>&nbsp`
                              );
                              setOpen3(false);
                              // emailBody=emailBody+`&nbsp<a style='color:#0000FF' href=${val.scheduling_url}?utm_source=userId&utm_content=node&utm_campaign=campaignId target="_blank" rel="noopener"> ${val.name} </a>&nbsp`
                              // this.buttonClick(
                              //   `${val.scheduling_url}?utm_source=userId&utm_content=node&utm_campaign=campaignId`,
                              //   2,
                              //   val.name
                              // );
                            }}
                          >
                            Insert link
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
            </div>
          </Box>
        </Fade>
      </Modal>
      <Modal
        open={open4}
        onClose={() => {
          setOpen4(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          className="modalPopupDelete"
          style={{ width: "45vw", top: "18%", left: "30%" }}
        >
          <div className="modaltext">Download Leads</div>
          <div className="modalsubtext">
            Choose which emails you would like to download and the format of the
            exported file.
          </div>
          <div className="chooseemaillistblock">
            Download format options
            <div className="emailslistdownloadbox">
              {downloadFileArr.map((val, idx) => {
                return (
                  <div className="downloadcheckbox">
                    <Radio
                      checked={fileType === val.name}
                      onClick={() => {
                        setFileType(val.name);
                      }}
                      style={{
                        color: "#1C485F",
                      }}
                    />
                    <div className="checkdownloadlabeltext">{val.name}</div>
                  </div>
                );
              })}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                setOpen4(false);
              }}
            >
              Cancel
            </div>
            <div
              className="continuebuttonmodal"
              onClick={async () => {
                let exportJson = [];
                let copyToEmail = replyData;

                await Promise.all(
                  copyToEmail.map((item) => {
                    item.Details.map((val) => {
                      val.Reply.map((value) => {
                        if (!value.NotInterested) {
                          exportJson.push({
                            Name: value.Data.Name,
                            Email: value.Data.Email,
                            Date: formatDate(value.Data.Date),
                          });
                        }
                      });
                    });
                  })
                );

                downloadBulk(exportJson);
              }}
            >
              Download
            </div>
          </div>
        </div>
      </Modal>
      <style>
        {
          `.MuiAutocomplete-root.MuiOutlinedInput-root.MuiAutocomplete-input{
            padding: 2.5px 4px 7.5px 5px !important;
          }`
        }
      </style>
    </div>
  );
};

export default Unibox;
